//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'PSS',
  data() {
    return {
      defaultJson: {
        'Immunocompromised Status': '免疫功能低下',
        'Ischemic Colitis': '缺血性结肠炎',
        'ASA Class': 'ASA 分级',
        Age: '年龄',
        'Peritonitis Stage': '腹膜炎分级',
        'Preoperative Organ Failure': '术前器官功能衰竭',
      },
      form: {
        age: '',
        asa: '',
        hinchey: '',
        immunoCompromized: '0',
        preopOrganFailure: '0',
        ischemicColitis: '0',
      },
      contentDescription: '',
      hasScore: false,
      disabled: false,
    }
  },
  created() {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key] == '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '--'
      } else {
        // (age <= 70 ? 1 : 2) + (asa >= 4 ? 3 : (asa == 3 ? 2 : 1)) + (hinchey >= 3 ? 2 : 1) + (preopOrganFailure ? 3 : 1) + (ischemicColitis ? 2 : 1) + (immunoCompromized ? 2 : 1)
        let result =
          (form.age <= 70 ? 1 : 2) +
          (form.asa >= 4 ? 3 : form.asa == 3 ? 2 : 1) +
          (form.hinchey >= 3 ? 2 : 1) +
          (form.preopOrganFailure ? 3 : 1) +
          (form.ischemicColitis ? 2 : 1) +
          (form.immunoCompromized ? 2 : 1)
        self.hasScore = true
        return String(result)
      }
    },
  },
}



// WEBPACK FOOTER //
// ./src/pages/formulas/ID/PSS.vue